import React from 'react';
import CheckBoxFilter from './CheckBoxFilter';

const CATEGORY_ID = [4];

export default function AgeRangeFilter({ useStagingMode = false, onStageChange = null }) {
  return (
    <CheckBoxFilter
        matchIds={CATEGORY_ID}
        title="Idade dos viajantes"
        ariaLabel="Idade dos Viajantes"
        useStagingMode={useStagingMode}
        onStageChange={onStageChange}
    />
  );
}



// WEBPACK FOOTER //
// ./src/views/v2/search/components/filter/components/AgeRangeFilter.jsx